import { getDate, getTime } from '@/utils/date';

export function date(value, type = 'minite') {
  if (!value) {
    return null;
  }
  const result = new Date(value);
  if (!result) {
    return null;
  }
  if (type === 'day') {
    return getDate(result);
  }
  return `${getDate(result)} ${getTime(result)}`;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/filters/date.ts